/* Farmstead pack — creatures: chicken, chick, cow, crow, butterfly, fish shadow.
   Requires sprites.js. Exposes window.SpriteCreatures = { creatures() } */
(function () {
  const L = window.SpriteLib || globalThis.SpriteLib;
  const { G, px, rect, disc, outline, flipX, hash } = L;

  /* ---- chicken 16x16 ---- */
  function chicken(dir, pose, f) {
    const g = G(16, 16);
    const bob = pose === 'idle' ? f : pose === 'walk' ? (f === 1 ? 1 : 0) : 0;
    const peck = pose === 'peck';
    const legs = (a, b) => { rect(g, a, 13, 1, 3, 'y1'); rect(g, a - 1, 15, 3, 1, 'y1'); rect(g, b, 13, 1, 3, 'y1'); rect(g, b - 1, 15, 3, 1, 'y1'); };

    if (dir === 'down' || dir === 'up') {
      disc(g, 8, 10 + bob, 4.4, 3.6, 'w');
      disc(g, 6, 9 + bob, 2, 1.6, 'n3');
      const hy = peck ? 11 : 6 + bob;
      disc(g, 8, hy, 2.6, 2.4, 'w');
      rect(g, 7, hy - 4, 1, 2, 'r1'); rect(g, 8, hy - 5, 1, 3, 'r1'); rect(g, 9, hy - 4, 1, 2, 'r1');
      if (dir === 'down') {
        px(g, 6, hy, 'K'); px(g, 10, hy, 'K');
        px(g, 8, hy + 2, 'y1'); px(g, 7, hy + 2, 'y1');
      } else { disc(g, 8, hy, 2.2, 1.8, 'w'); px(g, 8, hy - 1, 'n3'); }
      if (peck) { rect(g, 5, 6, 6, 3, 'w'); rect(g, 4, 5, 3, 2, 'n3'); }
      const l = pose === 'walk' ? (f === 0 ? [6, 10] : f === 1 ? [7, 10] : [6, 9]) : [6, 10];
      legs(l[0], l[1]);
    } else {
      const tailX = 2, headX = 11;
      disc(g, 7, 10 + bob, 4.6, 3.4, 'w');
      disc(g, 6, 9 + bob, 2, 1.4, 'n3');
      // tail feathers lag a pixel behind on walk
      const lag = pose === 'walk' && f === 2 ? 1 : 0;
      rect(g, tailX, 6 + bob + lag, 4, 2, 'w'); rect(g, tailX, 8 + bob + lag, 3, 2, 'n3');
      const hy = peck ? 11 : 6 + bob;
      disc(g, headX, hy, 2.4, 2.2, 'w');
      rect(g, headX - 1, hy - 4, 1, 2, 'r1'); rect(g, headX, hy - 5, 1, 3, 'r1'); rect(g, headX + 1, hy - 4, 1, 2, 'r1');
      px(g, headX + 1, hy, 'K');
      rect(g, headX + 2, hy + 1, 2, 1, 'y1'); px(g, headX + 3, hy + 2, 'y1');
      if (peck) { rect(g, 8, 7, 4, 3, 'w'); rect(g, tailX, 4, 4, 2, 'n3'); }
      const l = pose === 'walk' ? (f === 0 ? [6, 9] : f === 1 ? [7, 9] : [5, 8]) : [6, 9];
      legs(l[0], l[1]);
    }
    outline(g, 'K');
    return dir === 'left' ? flipX(g) : g;
  }

  function chick(f) {
    const g = G(12, 12);
    disc(g, 6, 7 + f, 3.4, 3, 'y2');
    disc(g, 6, 4 + f, 2.2, 2, 'y2');
    px(g, 5, 4 + f, 'K'); px(g, 7, 4 + f, 'K');
    px(g, 6, 6 + f, 'y1');
    rect(g, 4, 10, 1, 2, 'y1'); rect(g, 7, 10, 1, 2, 'y1');
    outline(g, 'K'); return g;
  }

  /* ---- cow 32x32 ---- */
  function cow(dir, pose, f) {
    const g = G(32, 32);
    const bob = pose === 'walk' ? (f === 1 ? 1 : 0) : 0;
    const leg = (x, dy) => { rect(g, x, 24 + dy, 4, 6, 'w'); rect(g, x, 28 + dy, 4, 2, 'K'); };
    const patches = (cx, cy) => { disc(g, cx - 5, cy - 2, 4, 3, 'b1'); disc(g, cx + 4, cy + 2, 3.4, 2.6, 'b1'); };

    if (dir === 'down' || dir === 'up') {
      const l = pose === 'walk' ? (f === 0 ? [0, 0] : f === 1 ? [-1, 0] : [0, -1]) : [0, 0];
      leg(7, l[0]); leg(21, l[1]);
      disc(g, 16, 18 + bob, 10, 7.5, 'w');
      patches(16, 18 + bob);
      disc(g, 16, 9 + bob, 6, 5, 'w');
      rect(g, 9, 5 + bob, 3, 3, 'w'); rect(g, 20, 5 + bob, 3, 3, 'w');
      if (dir === 'down') {
        px(g, 13, 9 + bob, 'K'); px(g, 19, 9 + bob, 'K');
        disc(g, 16, 13 + bob, 4, 2.4, 's'); px(g, 15, 13 + bob, 'K'); px(g, 18, 13 + bob, 'K');
        disc(g, 16, 24 + bob, 2.6, 1.8, 's');
      } else {
        disc(g, 16, 9 + bob, 5, 4, 'w'); disc(g, 14, 8 + bob, 2.4, 2, 'b1');
        rect(g, 15, 22 + bob, 2, 6, 'w'); px(g, 16, 28 + bob, 'K');
      }
    } else {
      const l = pose === 'walk' ? (f === 0 ? [0, 0] : f === 1 ? [-1, 0] : [0, -1]) : [0, 0];
      leg(8, l[0]); leg(18, l[1]);
      disc(g, 15, 18 + bob, 11, 7, 'w');
      patches(15, 18 + bob);
      disc(g, 25, 13 + bob, 5, 4.4, 'w');
      rect(g, 23, 8 + bob, 3, 3, 'w');
      px(g, 26, 13 + bob, 'K');
      disc(g, 29, 15 + bob, 2.4, 2, 's');
      // tail flicks on idle frame 2
      const tx = pose === 'idle' && f ? 3 : 4;
      rect(g, tx, 14 + bob, 1, 8, 'w'); px(g, tx, 22 + bob, 'K');
      disc(g, 17, 24 + bob, 2.4, 1.6, 's');
    }
    outline(g, 'K');
    return dir === 'left' ? flipX(g) : g;
  }

  /* ---- crow 16x16 ---- */
  function crow(kind, f) {
    const g = G(16, 16);
    if (kind === 'land') {
      disc(g, 8, 9, 4, 3.4, 'K'); disc(g, 7, 8, 2.4, 2, 'D');
      disc(g, 11, 5, 2.2, 2, 'K'); rect(g, 13, 5, 3, 1, 'y1');
      px(g, 11, 5, 'n1');
      rect(g, 3, 8, 4, 2, 'D');
      rect(g, 7, 12, 1, 3, 'n1'); rect(g, 10, 12, 1, 3, 'n1');
    } else {
      disc(g, 8, 8, 3.4, 2.6, 'K');
      disc(g, 11, 6, 2, 1.8, 'K'); rect(g, 13, 6, 3, 1, 'y1'); px(g, 11, 6, 'n1');
      const wy = f === 0 ? 2 : f === 1 ? 6 : 10;
      for (let i = 0; i < 6; i++) { px(g, 7 - i, wy + (f === 1 ? 0 : i * (f === 0 ? 1 : -1) * 0.4 | 0), 'K'); px(g, 7 - i, wy + 1, 'D'); }
      for (let i = 0; i < 5; i++) { px(g, 9 + i, wy + (f === 1 ? 0 : i * (f === 0 ? 1 : -1) * 0.4 | 0), 'K'); px(g, 9 + i, wy + 1, 'n1'); }
      rect(g, 4, 9, 3, 1, 'D');
    }
    outline(g, 'K'); return g;
  }

  function butterfly(f) {
    const g = G(12, 12);
    const c = f === 2 ? 'p2' : 'y2', c2 = f === 2 ? 'p1' : 'y1';
    rect(g, 5, 4, 2, 5, 'K');
    px(g, 5, 3, 'K'); px(g, 7, 3, 'K');
    if (f === 0) { disc(g, 3, 4, 2.4, 3, c); disc(g, 8, 4, 2.4, 3, c); px(g, 3, 4, c2); px(g, 8, 4, c2); }
    if (f === 1) { disc(g, 4, 5, 1.4, 3.4, c); disc(g, 7, 5, 1.4, 3.4, c); }
    if (f === 2) { disc(g, 3, 6, 2.6, 2.4, c); disc(g, 8, 6, 2.6, 2.4, c); px(g, 3, 6, c2); px(g, 8, 6, c2); }
    outline(g, 'K'); return g;
  }

  /* ---- fish shadow 24x24 (blended) ---- */
  function fishShadow(f) {
    const g = G(24, 24);
    const x = 6 + f * 4;
    disc(g, x, 12, 4.4, 2.2, 'c1');
    for (let i = 0; i < 4; i++) px(g, x - 5 - i, 12 + (i % 2 ? 1 : -1), 'c1');
    disc(g, x + 1, 11, 2, 1, 'cB');
    for (let i = 0; i < 6; i++) { px(g, x - 7 - i, 10 - (i > 3 ? 1 : 0), 'cA'); px(g, x - 7 - i, 14 + (i > 3 ? 1 : 0), 'cA'); }
    return g;
  }

  function creatures() {
    const out = [];
    const add = (cat, id, g, meta) => out.push(Object.assign({ cat, id, grid: g, w: g.w, h: g.h }, meta || {}));
    const DIRS = ['down', 'left', 'right', 'up'];

    DIRS.forEach(d => {
      [0, 1].forEach(f => add('creature', `chicken_idle_${d}_${f}`, chicken(d, 'idle', f), { priority: 'P1', anim: 'chicken_idle_' + d, frame: f }));
      [0, 1, 2].forEach(f => add('creature', `chicken_walk_${d}_${f}`, chicken(d, 'walk', f), { priority: 'P1', anim: 'chicken_walk_' + d, frame: f }));
      [0, 1].forEach(f => add('creature', `chicken_peck_${d}_${f}`, chicken(d, 'peck', f), { priority: 'P1', anim: 'chicken_peck_' + d, frame: f }));
    });
    [0, 1, 2].forEach(f => add('creature', 'fish_shadow_' + f, fishShadow(f), { priority: 'P1', anim: 'fish_shadow', frame: f, blended: true }));
    [0, 1].forEach(f => add('creature', 'chick_idle_' + f, chick(f), { priority: 'P2', anim: 'chick_idle', frame: f }));
    DIRS.forEach(d => {
      [0, 1].forEach(f => add('creature', `cow_idle_${d}_${f}`, cow(d, 'idle', f), { priority: 'P2', anim: 'cow_idle_' + d, frame: f }));
      [0, 1, 2].forEach(f => add('creature', `cow_walk_${d}_${f}`, cow(d, 'walk', f), { priority: 'P2', anim: 'cow_walk_' + d, frame: f }));
    });
    [0, 1, 2].forEach(f => add('creature', 'crow_fly_' + f, crow('fly', f), { priority: 'P2', anim: 'crow_fly', frame: f }));
    add('creature', 'crow_land', crow('land'), { priority: 'P2' });
    [0, 1, 2].forEach(f => add('creature', 'butterfly_' + f, butterfly(f), { priority: 'P2', anim: 'butterfly', frame: f }));
    return out;
  }

  const api = { creatures, chicken, cow, crow, butterfly, chick, fishShadow };
  if (typeof window !== 'undefined') window.SpriteCreatures = api;
  if (typeof globalThis !== 'undefined') globalThis.SpriteCreatures = api;
})();
